import axios from 'axios'
import {
	encryptLong,
	syShopSign
} from '@/utils/rsaEncrypt'


// 创建axios实例
const service = axios.create({
	// baseURL: 'https://test.app.yundangpu.vip/api',
	baseURL: 'https://yundangpu.vip/api',
	// baseURL: 'https://app.qulego8.com/api',
	timeout: 5000 // 请求超时时间
});
console.log(axios)
// 请求拦截器
service.interceptors.request.use(

	config => {
		// config.baseURL = config.type == 1 ? '/api' : 'https://test.app.yundangpu.vip/api'
		// config.baseURL = config.type == 1 ? '/api' : 'https://app.qulego8.com/api'
		config.baseURL = config.type == 1 ? '/api' : 'https://yundangpu.vip/api'
		let timeStamp = new Date().getTime()
		let nonce = Math.floor(1000000 + Math.random() * 9000000);// 7位随机数
		let sySign = syShopSign()
		let CheckCsrf = encryptLong(sySign + timeStamp + nonce)
		// 请求头
		config.headers['TimeStamp'] = timeStamp
		config.headers['CheckCsrf'] = CheckCsrf
		config.headers['nonce'] = nonce;
		config.headers['Content-Type'] = 'application/json'
		return config;
	},
	error => {
		// 请求错误处理
		console.error("Error:", error);
		Promise.reject(error);
	}
);

// 响应拦截器
service.interceptors.response.use(
	response => {
		// 对响应数据做处理，例如只返回data部分
		const res = response.data;
		if (res.status !== 200) {
			return Promise.reject(res.msg);
		} else {
			return res;
		}
		return response;
	},
	error => {
		console.error("Error:", error);
		return Promise.reject(error);
	}
);

export default service;


// WEBPACK FOOTER //
// ./src/utils/util.js